import React, { useEffect, useState } from "react";

const STORAGE_KEY = "mytacs-cookie-consent-v1";

/**
 * Schlanker Cookie-/Datenschutz-Hinweis.
 * Da MyTACS NUR technisch notwendige Cookies verwendet (kein Tracking, keine
 * Werbe-Cookies), ist gemäß § 25 Abs. 2 TTDSG keine Einwilligung erforderlich.
 * Wir zeigen aber zur Transparenz einen einmaligen Info-Hinweis mit Link zur
 * Datenschutzerklärung, der vom Nutzer ausgeblendet werden kann.
 */
export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ acceptedAt: new Date().toISOString() }));
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md bg-neutral-900 text-neutral-100 rounded-2xl shadow-2xl border border-neutral-700 p-5 z-[9999] animate-in fade-in slide-in-from-bottom-4 duration-300"
        >
            <h3 className="font-semibold mb-2 text-sm">Hinweis zu Cookies und Speicher</h3>
            <p className="text-xs leading-relaxed text-neutral-300 mb-3">
                MyTACS verwendet ausschließlich <strong>technisch notwendige Cookies</strong> und Local Storage,
                um Sie eingeloggt zu halten und UI-Einstellungen zu speichern.{" "}
                <strong>Kein Tracking, keine Werbung, keine Analyse-Tools.</strong>{" "}
                Mehr Infos in unserer{" "}
                <a href="/datenschutz" className="underline hover:text-white" data-testid="cookie-banner-privacy-link">
                    Datenschutzerklärung
                </a>.
            </p>
            <button
                onClick={accept}
                data-testid="cookie-banner-accept-button"
                className="w-full bg-neutral-100 hover:bg-white text-neutral-900 rounded-lg px-4 py-2 text-sm font-medium transition-colors"
            >
                Verstanden
            </button>
        </div>
    );
}
